import { render, staticRenderFns } from "./ExamIntro.vue?vue&type=template&id=76c1fbda&scoped=true"
import script from "./ExamIntro.vue?vue&type=script&lang=js"
export * from "./ExamIntro.vue?vue&type=script&lang=js"
import style0 from "./ExamIntro.vue?vue&type=style&index=0&id=76c1fbda&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76c1fbda",
  null
  
)

export default component.exports